<template>
  <article class="ws-fin-movimento-row" :class="`ws-fin-movimento-row--${tipoClass}`">
    <div class="ws-fin-movimento-row__bar" />
    <div
      class="ws-fin-movimento-row__flow-icon"
      :class="`ws-fin-movimento-row__flow-icon--${tipoClass}`"
      :title="tipoLabel"
      aria-hidden="true"
    >
      <svg v-if="tipoClass === 'entrada'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M7 11l5-5m0 0l5 5m-5-5v12" />
      </svg>
      <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.25">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 13l-5 5m0 0l-5-5m5 5V6" />
      </svg>
    </div>
    <div class="ws-fin-movimento-row__main">
      <div class="ws-fin-movimento-row__head">
        <span class="ws-fin-movimento-row__badge" :class="`ws-fin-movimento-row__badge--${tipoClass}`">
          {{ tipoLabel }}
        </span>
      </div>
      <p class="ws-fin-movimento-row__desc">{{ movimento.descricao || '—' }}</p>
      <p class="ws-fin-movimento-row__meta">
        <span class="ws-fin-movimento-row__date">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
          {{ formatDateBR(movimento.dataMovimento) }}
        </span>
      </p>
    </div>
    <div class="ws-fin-movimento-row__valor" :class="`ws-fin-movimento-row__valor--${tipoClass}`" aria-hidden="true">
      <MoneyAmount :value="movimento.valor" size="md" />
    </div>
    <div class="ws-fin-movimento-row__actions">
      <button
        type="button"
        class="ws-fin-movimento-row__btn ws-fin-movimento-row__btn--del"
        :title="t('common.delete')"
        @click="$emit('delete', movimento.id)"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
      </button>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'
import { formatDateBR } from '@/utils/financeiroServicosMetrics'

const props = defineProps({
  movimento: { type: Object, required: true }
})

defineEmits(['delete'])

const { t } = useI18n()

const tipoClass = computed(() => {
  const t = String(props.movimento.tipo || '').toUpperCase()
  return t === 'ENTRADA' ? 'entrada' : 'gasto'
})

const tipoLabel = computed(() => {
  return tipoClass.value === 'entrada'
    ? t('workspaceFinanceiroServicos.movimentoEntrada')
    : t('workspaceFinanceiroServicos.movimentoGasto')
})
</script>
